import { PaytrieAPI } from '@paytrie/client'
import * as Sentry from '@sentry/react'

export type Limits = PaytrieAPI.Limits

export const fetchLimits = async (): Promise<Limits | null> => {
  try {
    const res = await PaytrieAPI.getLimits()

    if (res.status !== 200 || !res.data.success) {
      throw new Error(`Limits fetch failed (status ${res.status})`)
    }

    return res.data.data
  } catch (error) {
    console.error(error)
    Sentry.captureException(error)
    return null
  }
}
